import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=995fbcf6&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=995fbcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995fbcf6",
  null
  
)

export default component.exports